export default __webpack_public_path__ + "static/media/success3.png";